/**
 * Validate a redirect target comes from the same origin.
 * Rejects protocol-relative URLs (//evil.com), backslash tricks (/\evil.com),
 * whitespace/tab bypasses (/%09evil.com, /\tevil.com), and non-path inputs.
 */
export function safeInternalPath(raw: unknown, fallback: string = '/'): string {
  if (typeof raw !== 'string' || raw.length === 0) return fallback
  if (!raw.startsWith('/')) return fallback
  if (/^\/[/\\]/.test(raw)) return fallback
  if (/^\/\s/.test(raw)) return fallback
  if (/^\/%(09|0a|0d|20|2f|5c)/i.test(raw)) return fallback
  return raw
}
